import { transport } from 'config/transport';

export function callApiDeleteThuDauNam(thuDauNamId) {
    return transport.del(`/mamnon/thuhocsinh/thudaunam/${thuDauNamId}`);
}
